/*
* Created by Rishabh Kumar on 22/11/19
* */

import * as React from "react";
import AppUtils from "../../utils/AppUtils";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import {SectionContext} from "../../utils/EventTrackerConstants";

interface ToggleSwitchProps {
    name?: string
    widgetName?: string
    enabled: boolean;
    onClick: (val: boolean) => void;
    label?: string;
    secondLabel?: string
}

export default class ToggleSwitch extends React.Component<ToggleSwitchProps> {
    static contextType = SectionContext;
    handleClick = () => {
        const val = AppUtils.isDefined(this.props.enabled) ? !this.props.enabled : true;
        // LocalStorageUtils.setClickEvents({ value: val, field: this.props.name || this.props.label, widget: this.props.widgetName, section: this.context })
        this.props.onClick(val);
    }

    render() {
        const activeCls = this.props.enabled ? "active" : "";
        return (
            <div className={"toggle-switch"}>
                {this.props.label && <span className={"" +
                ""}>{this.props.label}</span>}
                <div className={`switch-container ${activeCls}`} onClick={this.handleClick}>
                    <div className={"switch-inner"}/>
                </div>
                {this.props.secondLabel && <span className={"switch-label secondary"}>{this.props.secondLabel}</span>}
            </div>
        )
    }
}